// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dot[data-v-ee31cd86] {\n  height: 10px;\n  width: 10px;\n  border-radius: 50%;\n  display: inline-block;\n  margin-left: 5px;\n}\n", ""]);
// Exports
module.exports = exports;
